/**
 * Selector de elementos enfocables dentro del pop-up. Se usa para el focus
 * trap (Tab/Shift+Tab cíclico) y para mover el foco al primer control al
 * abrir — mismo selector ya usado por `BottomSheet`/`SideSheet`.
 */
export const FOCUSABLE_SELECTOR =
  'a[href], area[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
